import { createClient } from 'contentful';

const client = createClient({
  space: 'suvlvv12sp8x', // Replace with your actual space ID
  accessToken: 'vDAf5ibnTqn_rS8wKWlnpEtrTSLkUZUQIbkcq0hxThw' // Replace with your actual access token
});

export default client;
